// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { GetFundAndCffModelResponseFromJSON, } from '../models';
/**
 * Fetch funds and their associated models in a single response.
 * Get Funds with Associated Models
 */
export function getFundsAndCffModelsRaw(requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/cff/funds-and-models` + queryString,
        meta,
        update: requestConfig.update || {
            FundsAndCffModels: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(GetFundAndCffModelResponseFromJSON);
            return {
                FundsAndCffModels: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetFundsAndCffModels`;
    return config;
}
/**
* Fetch funds and their associated models in a single response.
* Get Funds with Associated Models
*/
export function getFundsAndCffModels(requestConfig) {
    return getFundsAndCffModelsRaw(requestConfig);
}
